<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useMessageContext } from '../provider.js';
import BaseAttachmentBubble from './BaseAttachment.vue';
import FileIcon from 'next/icon/FileIcon.vue';
import {
  getAttachmentFilename,
  getAttachmentFileExtension,
} from 'shared/helpers/attachmentHelper';

const { attachments } = useMessageContext();

const { t } = useI18n();

const attachment = computed(() => attachments.value[0]);

const url = computed(() => attachment.value?.dataUrl);

const fileName = computed(() => {
  const filename = getAttachmentFilename(attachment.value);
  return filename || t('CONVERSATION.UNKNOWN_FILE_TYPE');
});

const fileType = computed(() => getAttachmentFileExtension(fileName.value));
</script>

<template>
  <BaseAttachmentBubble
    icon="i-teenyicons-user-circle-solid"
    icon-bg-color="bg-n-alpha-3 dark:bg-n-alpha-white"
    sender-translation-key="CONVERSATION.SHARED_ATTACHMENT.FILE"
    :content="fileName"
    :action="{
      href: url,
      label: $t('CONVERSATION.DOWNLOAD'),
    }"
  >
    <template #icon>
      <FileIcon :file-type="fileType" class="size-4" />
    </template>
  </BaseAttachmentBubble>
</template>
